import { render, staticRenderFns } from "./numerico.vue?vue&type=template&id=32974e56"
import script from "./numerico.vue?vue&type=script&lang=js"
export * from "./numerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports